import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=2fb1ee7f&scoped=true&"
import script from "./CustomDrawer.vue?vue&type=script&lang=js&"
export * from "./CustomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=2fb1ee7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1ee7f",
  null
  
)

export default component.exports